import classnames from 'classnames/bind'

import ProductCard, { ProductCardProps } from '~/components/UI/ProductCard'
import { CardProductLayoutType } from '~/components/UI/ProductCard/types'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type ResultsProps = {
  items: ProductCardProps[]
  itemClassName?: string
  layout?: CardProductLayoutType
  withPriority?: boolean
}

function Results({ items, itemClassName, layout, withPriority }: ResultsProps) {
  return (
    <>
      {items?.map((product, index) => (
        <ProductCard
          {...product}
          key={`card_${layout}_${index}`}
          layout={layout}
          className={cx(css.product, itemClassName)}
          priority={withPriority && index === 0}
        />
      )) ?? null}
    </>
  )
}

export default Results
